import { isName } from './is-name';

export function validateLastName(lastName: string): true | string {
  return isName(lastName) || 'Invalid characters in last name';
}
